import { IssueTypes200Response, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import { UseIssueTypesParamsObject } from './use-issue-types';

export interface UseInfiniteIssueTypesParams {
  params?: UseIssueTypesParamsObject;
  enabled?: boolean;
  handleError?: boolean;
}

export function useInfiniteIssueTypes({
  params = {},
  enabled = true,
  handleError = false,
}: UseInfiniteIssueTypesParams) {
  const {
    page = 0,
    limit = 100,
    sortByName,
    filterById,
    filterByName,
    filterByEnabled,
    filterByIssueTypeManager,
    populateFields,
  } = params;

  const api = useApi();

  const queryKey = [
    'issue-types',
    page,
    limit,
    sortByName,
    filterById,
    filterByName,
    filterByEnabled,
    filterByIssueTypeManager,
    populateFields,
  ];

  return useInfiniteQuery<
    IssueTypes200Response,
    ExtendedAxiosError,
    InfiniteData<IssueTypes200Response>,
    typeof queryKey,
    number
  >({
    queryKey,
    queryFn: ({ pageParam }) =>
      api.issueTypesApi
        .issueTypes(
          pageParam,
          limit,
          sortByName,
          filterById,
          filterByName,
          filterByEnabled,
          filterByIssueTypeManager,
          populateFields?.populateIssueTypeManagers,
          populateFields?.populateIssueSubtypes,
          populateFields?.populateSubtypeIssueTypeManagers,
        )
        .then((r) => r.data),
    enabled,
    getNextPageParam: (lastPage) =>
      lastPage.meta.hasNextPage ? lastPage.meta.page + 1 : undefined,
    initialPageParam: page,
    meta: {
      handleError,
    },
  });
}
